/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Backdrop, Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Best_Sellers from "./Componentes/Home_Best_Sellers";
import Home_Categorias from "./Componentes/Home_Categorias";
import Home_Suscripcion from "./Componentes/Home_Suscripcion";
import {SECCIONES} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import logoRedondo from "../../Recursos/logo_redondo.svg";
import Home_Nueva_Coleccion from "./Componentes/Home_Nueva_Coleccion";
import Home_Compra_Look from "./Componentes/Home_Compra_Look";
import Home_Colecciones from "./Componentes/Home_Colecciones";

const Seccion_Home = () => {
    const {sCell, esSafari, masSM} = useResponsive()
    //aqui cambiar
    const [mirar, setMirar] = useState(true)

    useEffect(() => {
        //  irArriba()
    }, []);


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{zIndex: 1}}
            onLoadedData={() => setMirar(true)}
        >

            <Backdrop
                open={!mirar}
                sx={(theme) => ({color: '#fff', zIndex: theme.zIndex.drawer + 1})}
            >
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                        <img src={logoRedondo} width={100} height={'auto'} className={'cargando'}
                             alt={'Logo de la empresa'} title={'Logo'}/>
                    </Grid>

                </Grid>


            </Backdrop>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -15, zIndex: 2}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 2}}>
                <Home_Lineas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: !masSM ? 8 : 12}}>
                <Home_Best_Sellers/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: !masSM ? 8 : 14}}>
                <Home_Nueva_Coleccion/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: !masSM ? 8 : 12}}>
                <Home_Compra_Look/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: !masSM ? 8 : 14}}>
                <Home_Colecciones/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{pt: sCell ? 8 : 12}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 18, mb: sCell ? 8 : 16}}>
                <Home_Suscripcion/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home